import React, { useState, useEffect } from "react";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  Card,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { _add_website_faqs } from "../../DAL/website_faqs/website_faqs";
import { useSnackbar } from "notistack";
import { useContentSetting } from "../../Hooks/ContentContext/ContentSettingState";

export default function AddWebsiteFaqs() {
  const { userInfo, privilegeAccess } = useContentSetting();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [inputs, setInputs] = useState({
    question_statement: "",
    answer_statement: "",
    status: true,
  });
  const handleBack = () => {
    navigate(`/website-faqs`);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const objectData = {
      question_statement: inputs.question_statement,
      answer_statement: inputs.answer_statement,
      status: inputs.status,
    };
    const result = await _add_website_faqs(objectData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      navigate(`/website-faqs`);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  useEffect(() => {
    if (userInfo.type !== 0 && !privilegeAccess.add_website_faqs) {
      navigate(`/website-faqs`);
    }
  }, []);
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <IconButton onClick={handleBack} className="icon-button">
            <Icon icon="akar-icons:arrow-left" />
          </IconButton>
        </div>
        <div className="col-12">
          <h3 className="my-3">Add Website FAQ</h3>
        </div>
      </div>
      <Card
        sx={{
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          mb: 1,
          width: "100%",
          p: 2,
        }}>
        <form
          autoComplete="off"
          onSubmit={handleSubmit}
          encType="multipart/form-data">
          <div className="row table-form pt-2 pb-2">
            <div className="col-md-6 col-xs-12 ">
              <TextField
                id="outlined-basic"
                label="Question Statement"
                variant="outlined"
                sx={{ width: "100%" }}
                required
                name="question_statement"
                onChange={handleChange}
                value={inputs.question_statement}
              />
            </div>

            <div className="col-md-6 col-xs-12">
              <FormControl fullWidth sx={{ mb: 0 }}>
                <InputLabel id="demo-simple-select-label">
                  FAQ Status*
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="status"
                  defaultValue="true"
                  value={inputs.status}
                  required
                  label="FAQ Status"
                  onChange={handleChange}>
                  <MenuItem value={true}>Active</MenuItem>
                  <MenuItem value={false}>Inactive</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="col-12">
              <TextField
                id="outlined-multiline-static"
                label="Answer Statement"
                multiline
                rows={5}
                name="answer_statement"
                onChange={(e) => handleChange(e)}
                value={inputs.answer_statement}
                variant="outlined"
                style={{ width: "100%" }}
                required
              />
            </div>
            <div className="col-12 text-end">
              <button className="small-contained-button" type="submit">
                Submit
              </button>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
}
